import { http } from "../services/HttpService";
import { uiNotification } from "../services/UINotificationService";

export const getReferralSources = (formData) => {
  return (dispatch) => {
    dispatch({ type: "GET_REFERRAL_SOURCES_LOADING" });
    http
      .get("get-referral-sources", formData)
      .then((response) => {
        dispatch({
          type: "GET_REFERRAL_SOURCES_SUCCESS",
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "GET_REFERRAL_SOURCES_ERROR",
          payload: error.response?.data,
        });
        uiNotification.error(error.response?.data?.message);
      });
  };
};

export const changeReferralSourceStatus = (formData) => {
  return (dispatch) => {
    dispatch({ type: "GET_REFERRAL_SOURCES_LOADING" });
    http
      .post("change-status-referral-source", formData)
      .then((response) => {
        dispatch({
          type: "CHANGE_REFERRAL_SOURCES_SUCCESS",
          payload: response.data,
        });
        uiNotification.success(response.data?.message);
      })
      .catch((error) => {
        dispatch({
          type: "GET_REFERRAL_SOURCES_ERROR",
          payload: error.response?.data,
        });
        uiNotification.error(error.response?.data?.message);
      });
  };
};

export const addReferralSource = (formData) => {
  return (dispatch) => {
    dispatch({ type: "GET_REFERRAL_SOURCES_LOADING" });
    http
      .post("add-referral-source", formData)
      .then((response) => {
        dispatch({
          type: "ADD_REFERRAL_SOURCES_SUCCESS",
          payload: response.data,
        });
        uiNotification.success(response.data?.message);
      })
      .catch((error) => {
        dispatch({
          type: "GET_REFERRAL_SOURCES_ERROR",
          payload: error.response?.data,
        });
        uiNotification.error(error.response?.data?.message);
      });
  };
};

export const addReferralSourceSubcategory = (formData) => {
  return (dispatch) => {
    dispatch({ type: "GET_REFERRAL_SOURCES_LOADING" });
    return http
      .post("add-source-subcategory", formData)
      .then((response) => {
        dispatch({
          type: "ADD_REFERRAL_SOURCE_SUBCATEGORY_SUCCESS",
          payload: response.data,
        });
        uiNotification.success(response.data?.message);
      })
      .catch((error) => {
        dispatch({
          type: "GET_REFERRAL_SOURCES_ERROR",
          payload: error.response?.data,
        });
        uiNotification.error(error.response?.data?.message);
        throw error.response?.data;
      });
  };
};

export const changeReferralSubcategoryStatus = (formData) => {
  return (dispatch) => {
    dispatch({ type: "GET_REFERRAL_SOURCES_LOADING" });
    http
      .post("change-status-source-subcategory", formData)
      .then((response) => {
        dispatch({
          type: "ADD_REFERRAL_SOURCE_SUBCATEGORY_SUCCESS",
          payload: response.data,
        });
        uiNotification.success(response.data?.message);
      })
      .catch((error) => {
        dispatch({
          type: "GET_REFERRAL_SOURCES_ERROR",
          payload: error.response?.data,
        });
        uiNotification.error(error.response?.data?.message);
      });
  };
};

export const editReferralSourceName = (formData) => {
  return (dispatch) => {
    dispatch({ type: "GET_REFERRAL_SOURCES_LOADING" });
    http
      .post("edit-referral-source", formData)
      .then((response) => {
        dispatch({
          type: "ADD_REFERRAL_SOURCES_SUCCESS",
          payload: response.data,
        });
        uiNotification.success(response.data?.message);
      })
      .catch((error) => {
        dispatch({
          type: "GET_REFERRAL_SOURCES_ERROR",
          payload: error.response?.data,
        });
        uiNotification.error(error.response?.data?.message);
      });
  };
};

export const deleteReferralSource = (formData) => {
  return (dispatch) => {
    dispatch({ type: "GET_REFERRAL_SOURCES_LOADING" });
    http
      .post("delete-referral-source", formData)
      .then((response) => {
        dispatch({
          type: "ADD_REFERRAL_SOURCES_SUCCESS",
          payload: response.data,
        });
        uiNotification.success(response.data?.message);
      })
      .catch((error) => {
        dispatch({
          type: "GET_REFERRAL_SOURCES_ERROR",
          payload: error.response?.data,
        });
        uiNotification.error(error.response?.data?.message);
      });
  };
};

export const editReferralSubcategoryName = (formData) => {
  return (dispatch) => {
    dispatch({ type: "GET_REFERRAL_SOURCES_LOADING" });
    http
      .post("edit-source-subcategory", formData)
      .then((response) => {
        dispatch({
          type: "ADD_REFERRAL_SOURCE_SUBCATEGORY_SUCCESS",
          payload: response.data,
        });
        uiNotification.success(response.data?.message);
      })
      .catch((error) => {
        dispatch({
          type: "GET_REFERRAL_SOURCES_ERROR",
          payload: error.response?.data,
        });
        uiNotification.error(error.response?.data?.message);
      });
  };
};

export const deleteSubcategorySource = (formData) => {
  return (dispatch) => {
    dispatch({ type: "GET_REFERRAL_SOURCES_LOADING" });
    http
      .post("delete-source-subcategory", formData)
      .then((response) => {
        dispatch({
          type: "ADD_REFERRAL_SOURCE_SUBCATEGORY_SUCCESS",
          payload: response.data,
        });
        uiNotification.success(response.data?.message);
      })
      .catch((error) => {
        dispatch({
          type: "GET_REFERRAL_SOURCES_ERROR",
          payload: error.response?.data,
        });
        uiNotification.error(error.response?.data?.message);
      });
  };
};

export const changeObAvailability = (dto) => {
  return async (dispatch) => {
    dispatch({ type: "GET_REFERRAL_SOURCES_LOADING" });
    try {
      const response = await http.post(
        "change-ob-availability-referral-source",
        dto,
      );
      dispatch({
        type: "CHANGE_REFERRAL_SOURCES_SUCCESS",
        payload: response.data,
      });
      uiNotification.success(response.data?.message);
      return response;
    } catch (error) {
      dispatch({
        type: "GET_REFERRAL_SOURCES_ERROR",
        payload: error.response?.data,
      });
      uiNotification.error(error.response?.data?.message);
    }
  };
};

export const reorderReferralSources = async (formData) => {
  try {
    const res = await http.post("set-ob-order-referral-source", formData);
    uiNotification.success(res.data?.message);
    return res;
  } catch (error) {
    uiNotification.error(error.response?.data?.message);
  }
};
